var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { MenuItem } from '@mui/material';
import { MENSAGENS } from '../../../utils';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getCidade, cadastrarCidade, alterarCidade, excluirCidade } from './cidades_service';
import { getEstadosAtivos } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
import InputDados from '../../../components/input_dados';
export var CidadesAlterar = function () {
    var _a = useState([]), estadosDisponiveis = _a[0], setEstadosDisponiveis = _a[1];
    useEffect(function () {
        var carregarEstados = function () { return __awaiter(void 0, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getEstadosAtivos()];
                    case 1:
                        resp = _a.sent();
                        setEstadosDisponiveis(resp !== null && resp !== void 0 ? resp : []);
                        return [2 /*return*/];
                }
            });
        }); };
        carregarEstados();
    }, []);
    var services = {
        getItem: getCidade,
        cadastrarItem: cadastrarCidade,
        alterarItem: alterarCidade,
        excluirItem: excluirCidade,
    };
    var renderCamposAdicionais = function (dados, setDados, desabilitar) { return (_jsxs(_Fragment, { children: [_jsx(InputDados, { id: 'codigo_ibge', label: 'C\u00F3digo IBGE', value: dados.codigo_ibge || '', onChange: function (event) { return setDados(__assign(__assign({}, dados), { codigo_ibge: event.target.value })); }, mask: '99999999', variant: 'outlined', size: 'small', fullWidth: true, required: true, disabled: desabilitar }), _jsxs(InputDados, __assign({ select: true, id: 'estado', label: 'Estado', placeholder: 'Estado', value: dados.uf || '-1', onChange: function (event) { return setDados(__assign(__assign({}, dados), { uf: event.target.value })); }, fullWidth: true, disabled: desabilitar }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: 'Selecione ...' }), '-1'), estadosDisponiveis === null || estadosDisponiveis === void 0 ? void 0 : estadosDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.sigla }, { children: item.nome }), item.sigla)); })] }))] })); };
    var validarExtra = function (dados) {
        if (!dados.codigo_ibge || dados.codigo_ibge.trim() === '') {
            alert("C\u00F3digo IBGE ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!dados.uf || dados.uf === '-1') {
            alert("Estado ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        return true;
    };
    var formatarDadosExtra = function (dados) { return ({
        codigo_ibge: dados.codigo_ibge ? dados.codigo_ibge.replace(/\D/g, '') : '',
        uf: dados.uf,
    }); };
    return (_jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.CIDADES, paginaPermissao: FUNCIONALIDADES.CIDADES, rota: ROUTES.CIDADES, services: services, camposAdicionais: renderCamposAdicionais, validarExtra: validarExtra, formatarDadosExtra: formatarDadosExtra }));
};
export default CidadesAlterar;
